const COMMENT_TYPES = {
  COMMENT: 'COMMENT',
  DEEP_COMMENT: 'DEEP_COMMENT',
  REPLY: 'REPLY'
};
export default COMMENT_TYPES;